// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueCheckBoxPopupLazyLoading.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var observer = require('mobx-react').observer;
  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var OverflowText = require('share/components/controls/Izenda.OverflowText');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var LazyLoading = require('share/components/controls/LazyLoading/Izenda.LazyLoading');
  var localizer = require('share/localization/Izenda.Localizer');
  var OPERATORVALUE_CHECKBOX_POPUP_HEIGHT = 300;
  var DEFAULT_ITEMS_PER_ROW = 3;
  const { clone, without, identity } = require('lodash/fp');
  var OperatorValueCheckBoxPopup = React.createClass({
    propTypes: {
      filterSource: React.PropTypes.object.isRequired,
      filterInfo: React.PropTypes.object.isRequired,
      showPopup: React.PropTypes.bool,
      applyFormater: React.PropTypes.func,
      onChange: React.PropTypes.func
    },

    componentWillMount: function() {
      var filterInfo = this.props.filterInfo || {};
      this.selectedValues = clone(filterInfo.value);
      this.props.updateKeepShowingHost && this.props.updateKeepShowingHost(true);
    },

    handleValueChange: function(item) {
      item.checked = !item.checked;

      if (item.checked) {
        this.selectedValues.push(item.value);
      } else {
        this.selectedValues = without([item.value], this.selectedValues);
      }
    },

    onClosingPopup: function(type) {
      var props = this.props;
      if (type === 'accept') {
        props.onChange && props.onChange(this.selectedValues);
        props.onAccept();
      } else if (type === 'cancel') {
        props.onReject();
      }
      props.updateKeepShowingHost && props.updateKeepShowingHost(false);
    },

    renderItemPopup: function(item) {
      var applyFormater = this.props.applyFormater || identity;
      var label = applyFormater(item.value);

      return <ItemCheckboxPopup item={item} label={label} onChange={this.handleValueChange} />;
    },

    getData: function(pageInfo) {
      var store = this.props.store;
      var info = {
        fromIndex: pageInfo.fromIndex,
        pageSize: pageInfo.pageSize * DEFAULT_ITEMS_PER_ROW
      };
      store.getData(info, this.props.configField);
    },

    render: function() {
      var props = this.props;
      var popupTitle = props.operatorGroup.fieldDetails.alias;
      var isLastPage = props.configField.operatorSourceDisplay.isLastPage;
      var source =
        props.configField.operatorSourceDisplay.data.length > 0 ? props.configField.operatorSourceDisplay.data : [];
      const zIndex = 1061;
      return (
        <Popup
          visible
          onClosed={this.onClosingPopup}
          autoClose
          type='none'
          style={{ zIndex }}
          backdropStyle={{ zIndex: zIndex - 1 }}
        >
          <Popup.Header title={popupTitle} />
          <Popup.Body>
            <div className='izenda-DefaultPopupContentWrapper'>
              <ScrollBox>
                <GridLayout>
                  <GridLayout.Row className='u_noMarginAll'>
                    <LazyLoading
                      data={source}
                      viewHeight={OPERATORVALUE_CHECKBOX_POPUP_HEIGHT}
                      isLastPage={isLastPage}
                      getData={this.getData}
                      renderItem={this.renderItemPopup}
                      itemClassName='izenda-GridLayout-Col4'
                    />
                  </GridLayout.Row>
                </GridLayout>
              </ScrollBox>
            </div>
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type='accept'>{localizer.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type='cancel'>
              {localizer.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );
    }
  });

  var ItemCheckboxPopup = observer(function(props) {
    var item = props.item;

    return (
      <div className='checkbox u_noMarginTop' key={'chk-' + item.value}>
        <label>
          <input type='checkbox' value={item.value} checked={item.checked} onChange={props.onChange.bind(null, item)} />
          <OverflowText tooltip={props.label}>{props.label}</OverflowText>
        </label>
      </div>
    );
  });

  module.exports = observer(OperatorValueCheckBoxPopup);
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueCheckBoxPopupLazyLoading.jsx